(() => {
  if (window.MasterCartPressureLoaded) return;
  window.MasterCartPressureLoaded = true;

  const randomInt = (min,max) => Math.floor(Math.random()*(max-min+1))+min;
  const replace = (tpl,token,value) => String(tpl||'').split(token).join(String(value));
  const reduced = matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const conversionConfig = () => document.querySelector('[data-master-conversion-config]')?.dataset || null;
  const cartCroConfig = () => document.querySelector('[data-master-cart-cro-config]')?.dataset || null;

  const applyConfig = root => {
    const cfg = conversionConfig();
    if (!cfg) return;
    const cartCfg = cartCroConfig();
    const isCartPage = root.dataset.pressureLocation === 'cart-page';
    const sharedToCart = cartCfg?.shareCartPage !== 'false';
    root.dataset.enabled = (isCartPage && !sharedToCart) ? 'false' : (cfg.urgencyShow || 'false');
    root.dataset.stockSource = cfg.stockSource || 'shopify';
    root.dataset.manualStock = cfg.manualStock || '0';
    root.dataset.manualReal = cfg.manualReal || 'false';
    root.dataset.dynamicStart = cfg.dynamicStart || '0';
    root.dataset.dynamicMin = cfg.dynamicMin || '0';
    root.dataset.dynamicStep = cfg.dynamicStep || '1';
    root.dataset.dynamicInterval = cfg.dynamicInterval || '60';
    root.dataset.persist = cfg.stockPersist || 'true';
    root.dataset.lowThreshold = cfg.lowThreshold || '8';
    root.dataset.stateZero = cfg.stateZero || 'Agotado';
    root.dataset.stateLow = cfg.stateLow || 'Casi agotado';
    root.dataset.stateOk = cfg.stateOk || 'Disponible';
    root.dataset.lock = cfg.lockZero || 'false';
    root.dataset.stockTemplate = cfg.stockText || '[stock]';
    root.dataset.viewersShow = cfg.viewersShow || 'false';
    root.dataset.viewersMode = cfg.viewersMode || 'manual';
    root.dataset.viewersManual = cfg.viewersManual || '0';
    root.dataset.viewersMin = cfg.viewersMin || '0';
    root.dataset.viewersMax = cfg.viewersMax || '0';
    root.dataset.viewersInterval = cfg.viewersInterval || '30';
    root.dataset.viewersTemplate = cfg.viewersText || '[count]';
    root.classList.remove('master-cart-pressure--premium','master-cart-pressure--compact','master-cart-pressure--minimal');
    root.classList.add(`master-cart-pressure--${cfg.urgencyStyle || 'premium'}`);
    const viewerWrap = root.querySelector('.master-cart-pressure__viewers');
    if (viewerWrap) viewerWrap.hidden = cfg.viewersShow !== 'true';
  };

  const setupPressure = root => {
    root._masterCleanup?.();
    applyConfig(root);
    root.dataset.masterReady = 'true';

    const enabled = root.dataset.enabled === 'true';
    const cartCount = Number(document.querySelector('[data-drawer-count]')?.textContent || 0);
    root.hidden = !enabled || cartCount <= 0;

    const source = root.dataset.stockSource || 'shopify';
    const start = source === 'shopify' ? Number(root.dataset.shopifyStock || 0) : source === 'manual' ? Number(root.dataset.manualStock || 0) : Number(root.dataset.dynamicStart || 0);
    const min = Number(root.dataset.dynamicMin || 0);
    const step = Math.max(1,Number(root.dataset.dynamicStep || 1));
    const interval = Math.max(5,Number(root.dataset.dynamicInterval || 60))*1000;
    const threshold = Math.max(1,Number(root.dataset.lowThreshold || 8));
    const stateZero = root.dataset.stateZero || 'Agotado';
    const stateLow = root.dataset.stateLow || 'Casi agotado';
    const stateOk = root.dataset.stateOk || 'Disponible';
    const stockCopy = root.querySelector('[data-pressure-stock-copy]');
    const bar = root.querySelector('[data-pressure-stock-bar]');
    const stateLabel = root.querySelector('[data-pressure-state]');
    const viewers = root.querySelector('[data-pressure-viewers-copy]');
    const stockTemplate = root.dataset.stockTemplate || '[stock]';
    // Solo se puede bloquear el checkout con una fuente de inventario REAL y verificable.
    // Si Shopify no rastrea el inventario de la variante, inventory_quantity vale 0 y no
    // significa "agotado": bloquear ahí dejaba el checkout muerto en productos sin tracking.
    const shopifyTracked = root.dataset.shopifyTracked === 'true';
    const canLock = enabled && root.dataset.lock === 'true' && (
      (source === 'shopify' && shopifyTracked) ||
      (source === 'manual' && root.dataset.manualReal === 'true')
    );
    const key = `master-pressure:${location.host}:${source}`;
    let value = start;
    let at = Date.now();

    const dynamicSignature = [start,min,step,interval].join('|');
    if (source === 'dynamic' && root.dataset.persist === 'true') {
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
        if (saved.signature === dynamicSignature) {
          value = Number.isFinite(Number(saved.value)) ? Number(saved.value) : start;
          at = Number(saved.at || Date.now());
        }
      } catch (_) {}
      const passed = Math.floor(Math.max(0,Date.now()-at)/interval);
      if (passed > 0) { value = Math.max(min,value-passed*step); at = Date.now(); }
    }

    // Solo revertimos lo que bloqueó la urgencia. Desbloquear a ciegas reactivaba el
    // checkout de un carrito vacío, que Liquid ya había deshabilitado a propósito.
    const setLocked = locked => {
      root.classList.toggle('is-locked',locked);
      document.querySelectorAll('[data-native-checkout],[data-master-payment],[data-cart-page-checkout]').forEach(el => {
        if (locked) {
          el.dataset.pressureLocked = 'true';
          if ('disabled' in el) el.disabled = true;
          el.setAttribute('aria-disabled','true');
          el.classList.add('is-disabled');
        } else if (el.dataset.pressureLocked === 'true') {
          delete el.dataset.pressureLocked;
          if ('disabled' in el) el.disabled = false;
          el.setAttribute('aria-disabled','false');
          el.classList.remove('is-disabled');
        }
      });
    };

    const paint = n => {
      n = Math.max(0,Number(n)||0);
      value = n;
      if (stockCopy) stockCopy.textContent = replace(stockTemplate,'[stock]',n);
      const base = Math.max(start,threshold,1);
      const pct = Math.max(0,Math.min(100,n/base*100));
      if (bar) bar.style.width = `${pct}%`;
      root.classList.toggle('is-low',n<=threshold && n>0);
      root.classList.toggle('is-zero',n<=0);
      // El estado por encima del umbral lo escribe el merchant. Fijarlo en
      // «Disponibilidad limitada» declaraba escasez sobre CUALQUIER cifra: con
      // inventario real de Shopify, 687 unidades salian etiquetadas como
      // limitadas sin que nadie lo hubiera decidido. El tramo sano es neutro
      // por defecto y sigue admitiendo copy agresivo a proposito.
      if (stateLabel) stateLabel.textContent = n<=0?stateZero:n<=threshold?stateLow:stateOk;
      setLocked(canLock && n<=0);
      if (source === 'dynamic' && root.dataset.persist === 'true') {
        try { sessionStorage.setItem(key,JSON.stringify({value:n,at:Date.now(),signature:dynamicSignature})); } catch (_) {}
      }
    };

    paint(value);
    let stockTimer = null;
    if (enabled && source === 'dynamic' && !reduced) stockTimer = setInterval(() => paint(Math.max(min,value-step)),interval);

    let viewerTimer = null;
    const paintViewers = () => {
      if (!viewers || root.dataset.viewersShow !== 'true') return;
      const mode = root.dataset.viewersMode || 'manual';
      const minView = Number(root.dataset.viewersMin || 0);
      const maxView = Math.max(minView,Number(root.dataset.viewersMax || 0));
      const n = mode === 'dynamic' ? randomInt(minView,maxView) : Number(root.dataset.viewersManual || 0);
      viewers.textContent = replace(root.dataset.viewersTemplate || '[count]','[count]',n);
    };
    paintViewers();
    if (enabled && viewers && root.dataset.viewersShow === 'true' && root.dataset.viewersMode === 'dynamic' && !reduced) {
      viewerTimer = setInterval(paintViewers,Math.max(5,Number(root.dataset.viewersInterval||30))*1000);
    }

    root._masterPressure = {paint,source};
    root._masterCleanup = () => { clearInterval(stockTimer); clearInterval(viewerTimer); };
  };

  const init = scope => {
    const roots = scope.matches?.('[data-cart-pressure]') ? [scope] : [...scope.querySelectorAll?.('[data-cart-pressure]') || []];
    roots.forEach(setupPressure);
  };

  init(document);
  document.addEventListener('shopify:section:load',e => init(e.target));
  // Sin esto, reordenar o borrar una seccion en el editor dejaba vivos los
  // intervals de stock dinamico y de viewers de la seccion ya retirada.
  document.addEventListener('shopify:section:unload',e => e.target.querySelectorAll?.('[data-cart-pressure]').forEach(el => el._masterCleanup?.()));
  document.addEventListener('master:conversion-config',() => document.querySelectorAll('[data-cart-pressure]').forEach(setupPressure));
  document.addEventListener('master:cart-cro-config',() => document.querySelectorAll('[data-cart-pressure]').forEach(setupPressure));
  document.addEventListener('master:cart-updated',e => {
    const cart = e.detail?.cart;
    const active = Number(cart?.item_count || 0) > 0;
    document.querySelectorAll('[data-cart-pressure]').forEach(el => {
      const enabled = el.dataset.enabled === 'true';
      el.hidden = !enabled || !active;
      if (!enabled || !active || el._masterPressure?.source !== 'shopify') return;
      const item = cart?.items?.[0];
      if (!item) return;
      const productRoot = document.querySelector(`[data-master-product][data-product-id="${item.product_id}"]`);
      if (!productRoot) return;
      const inventory = Number(productRoot.dataset.currentInventory);
      if (!Number.isFinite(inventory)) return;
      const tracked = productRoot.dataset.inventoryTracked === 'true';
      // El drawer se renderiza en el servidor con el carrito anterior. Si el producto en
      // carrito cambió de variante/tracking, hay que recalcular canLock, no solo repintar.
      if (el.dataset.shopifyTracked !== String(tracked)) {
        el.dataset.shopifyTracked = String(tracked);
        el.dataset.shopifyStock = String(Math.max(0, inventory));
        setupPressure(el);
        return;
      }
      el._masterPressure.paint(inventory);
    });
  });

  document.addEventListener('click',event => {
    const cod = event.target.closest('[data-cod-target-selector]');
    if (!cod) return;
    const selector = cod.dataset.codTargetSelector?.trim();
    if (!selector) return;
    let target = null;
    try { target = document.querySelector(selector); } catch (_) {}
    if (target) { event.preventDefault(); document.dispatchEvent(new CustomEvent('master:cart-force-close')); setTimeout(() => target.click(),80); }
  });
})();
